/* eslint-disable prettier/prettier */
<template>
    <div class="pb-3">
        <div class="text-center" v-if="popupBatchUpdate.isLoading">
            <img src="@/assets/loading-logo-animation.gif" style="width: 75px" />

            <p class="font-weight-bold">{{ $t('THE_SYSTEM_IS_LOADING') }}</p>
        </div>
        <v-row align="center" v-if="!popupBatchUpdate.isLoading" class="m-0">
            <v-col md="8" class="pt-0">
            </v-col>
            <v-col class="text-right pt-0">
                <v-btn color="primary" @click="confirmUpdateSpecialPrice()" :disabled="popupBatchUpdate.isLoading">
                    <template>{{ $t("UPDATE") }}</template>
                </v-btn>
            </v-col>
        </v-row>
        <div class="d-flex px-3 pb-3 w-100 justify-content-between" v-if="!popupBatchUpdate.isLoading">
            <div class="pt-0 w-100">
                <label class="pr-0">
                    {{ $t("ROOM_TYPE") }} *
                </label>
                <v-autocomplete item-text="text" item-value="value" :items="listRoom"
                    v-model="popupBatchUpdate.price.selectedRoomType" outlined chips dense multiple
                    @change="$event => changeRoomSelect($event)">
                    <template v-slot:prepend-item>
                        <p class="mx-3 mt-1"> <a class="text-primary"
                                @click="popupBatchUpdate.price.selectedRoomType = listRoom.map(e => e.value)">{{
                                    $t('SELECT_ALL') }}</a>
                            | <a class="text-primary" @click="popupBatchUpdate.price.selectedRoomType = []">{{
                                $t('UN_SELECT_ALL') }}</a>
                        </p>
                    </template>
                    <template v-slot:selection="{ item, index }">
                        <v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
                            :input-value="item.selected" close
                            @click:close="removeChips(index, popupBatchUpdate.price.selectedRoomType)" @click="item.select">
                            <span>{{ item.text }}</span>
                        </v-chip>
                        <span v-if="index === 2" class="grey--text caption">(+{{
                            popupBatchUpdate.price.selectedRoomType.length - 2 }})</span>
                    </template>
                    <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                </v-autocomplete>
            </div>
        </div>

        <div class="config-price" v-if="!popupBatchUpdate.isLoading">
            <template>
                <div class="w-100">
                    <div class="d-sticky h-header-table d-flex">
                        <div class="mr-auto">

                        </div>
                        <div>
                            <div class="small-gutters d-flex">
                                <div class="text-center font-weight-bold"
                                    :style="item.code === 'MON' ? 'width: 112px' : 'width: 94px'"
                                    v-for="item in popupBatchUpdate.daysOfWeek">{{ item.value }}</div>
                            </div>
                        </div>
                    </div>
                    <template
                        v-for="(room, roomIndex) in popupBatchUpdate.price.hasRoomRate.filter(temp => popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId))">
                        <div class="px-3 pt-2">
                            <span class="font-weight-bold text-primary">
                                {{ room.romTypeNameI18ns.find(x => x.lang == defaultI18n).name }}
                            </span>
                            <p v-if="`${room.roomTypeId}` in updateErrors" class="mb-0 protection-rate-error text-danger">{{updateErrors[`${room.roomTypeId}`]}}</p>
                            <div class="mb-3">
                                <b-row class="mb-1">
                                    <v-col md="6" class="pb-0 pt-1">
                                        <div class="d-flex align-center h-100 text-primary">

                                        </div>
                                    </v-col>
                                    <v-col md="6" class="py-0 text-right">
                                        <div class="text-right d-flex justify-content-end">
                                            <span class="font-weight-bold" v-if="roomIndex === 0">
                                                Master
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <i class="icon-info fs-16" v-bind="attrs" v-on="on"></i>
                                                    </template>
                                                    <span>{{ $t('TOOLTIP_MASTER') }}</span>
                                                </v-tooltip>
                                            </span>
                                            <div class="d-flex align-center justify-content-end d-multiplier" v-else>
                                                <div class="mr-1">
                                                    <span class="font-weight-bold"> Master *</span>
                                                </div>
                                                <div>
                                                    <currency-ptd
                                                        :classC="'input-multiplier v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
                                                        :options="multiplierOption"
                                                        v-model.lazy="room.multiplier"></currency-ptd>
                                                </div>
                                                <span class="font-weight-bold pl-1 pr-1"> + </span>
                                                <div class="mr-1">
                                                    <currency-ptd
                                                        :classC="'input-plus v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " v-model.lazy="room.plus"></currency-ptd>
                                                </div>
                                                <v-btn color="primary" outlined x-small @click="copyMasterRate(room)"
                                                    :title="$t('COPY_BY_FOMULAR')">
                                                    <v-icon size="16">move_down</v-icon>
                                                </v-btn>
                                            </div>
                                            <div class="ml-3 d-flex align-center">
                                                <v-btn color="primary" x-small class="ml-1" :title="$t('COPY')"
                                                    @click="copyMaster(room.dates)">
                                                    <i class="icon-copy_all fs-16"></i>
                                                </v-btn>
                                                <v-btn color="primary" x-small class="ml-1" :title="$t('PASTE')"
                                                    @click="pasteMaster(room)" v-if="objectCopy">
                                                    <i class="icon-content_paste fs-16"></i>
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-col>
                                </b-row>
                                <template v-for="(date, indDate) in room.dates">
                                    <div class="d-flex mb-2">
                                        <div class="pb-0 d-date mr-auto">
                                            <template v-if="roomIndex === 0">
                                                <div class="d-flex align-items-center">
                                                    <date-picker :disabled-date="notBeforeToday" @input="changDate(room)"
                                                        :confirm="true" :confirm-text="$t('CONFIRM')" :clearable="false"
                                                        :popup-class="'popup-calendar-desktop-detailhotel'"
                                                        v-model="date.dateSelect" :lang="languageDate"
                                                        :format="'DD/MM/YYYY'" :shortcuts="[]" range
                                                        placeholder="Select date range">
                                                    </date-picker>
                                                    <v-btn v-if="room.dates.length > 1" color="red"
                                                        @click="removePeriodSpecialPrice(indDate)" class="ml-1" icon
                                                        small><i class="icon-delete fs-16"></i></v-btn>
                                                </div>
                                            </template>
                                            <template v-else>
                                                {{ _moment(date.dateSelect[0]).format("DD/MM/YYYY") }} -
                                                {{ _moment(date.dateSelect[1]).format("DD/MM/YYYY") }}
                                            </template>
                                        </div>
                                        <div>
                                            <div class="small-gutters">
                                                <div class="pb-0 pt-0 d-flex align-items-center">
                                                    <v-btn color="primary" @click="copyPrice(date)" :title="$t('COPY')" icon
                                                        small><i class="icon-content_paste_go fs-16"></i></v-btn>
                                                    <currency-ptd
                                                        :classC="[
                                                            'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                                            `${room.roomTypeId}` in updateErrors && 
                                                            protectionRateInvalid(room.priceMin, room.priceMax, date['MON'].value) 
                                                            ? 'protection-border-danger' 
                                                            : ''
                                                        ].filter(Boolean).join(' ')"
                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="date['MON'].disable"
                                                        v-model.lazy="date['MON'].value" />
                                                </div>
                                                <div>
                                                    <currency-ptd
                                                        :classC="[
                                                            'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                                            `${room.roomTypeId}` in updateErrors && 
                                                            protectionRateInvalid(room.priceMin, room.priceMax, date['TUE'].value) 
                                                            ? 'protection-border-danger' 
                                                            : ''
                                                        ].filter(Boolean).join(' ')"
                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="date['TUE'].disable"
                                                        v-model.lazy="date['TUE'].value" />
                                                </div>
                                                <div>
                                                    <currency-ptd
                                                        :classC="[
                                                            'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                                            `${room.roomTypeId}` in updateErrors && 
                                                            protectionRateInvalid(room.priceMin, room.priceMax, date['WED'].value) 
                                                            ? 'protection-border-danger' 
                                                            : ''
                                                        ].filter(Boolean).join(' ')"
                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="date['WED'].disable"
                                                        v-model.lazy="date['WED'].value" />
                                                </div>
                                                <div>
                                                    <currency-ptd
                                                        :classC="[
                                                            'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                                            `${room.roomTypeId}` in updateErrors && 
                                                            protectionRateInvalid(room.priceMin, room.priceMax, date['THU'].value) 
                                                            ? 'protection-border-danger' 
                                                            : ''
                                                        ].filter(Boolean).join(' ')"
                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="date['THU'].disable"
                                                        v-model.lazy="date['THU'].value" />
                                                </div>
                                                <div>
                                                    <currency-ptd
                                                        :classC="[
                                                            'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                                            `${room.roomTypeId}` in updateErrors && 
                                                            protectionRateInvalid(room.priceMin, room.priceMax, date['FRI'].value) 
                                                            ? 'protection-border-danger' 
                                                            : ''
                                                        ].filter(Boolean).join(' ')"
                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="date['FRI'].disable"
                                                        v-model.lazy="date['FRI'].value" />
                                                </div>
                                                <div>
                                                    <currency-ptd
                                                        :classC="[
                                                            'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                                            `${room.roomTypeId}` in updateErrors && 
                                                            protectionRateInvalid(room.priceMin, room.priceMax, date['SAT'].value) 
                                                            ? 'protection-border-danger' 
                                                            : ''
                                                        ].filter(Boolean).join(' ')"
                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="date['SAT'].disable"
                                                        v-model.lazy="date['SAT'].value" />
                                                </div>
                                                <div class="mr-0">
                                                    <currency-ptd
                                                        :classC="[
                                                            'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                                            `${room.roomTypeId}` in updateErrors && 
                                                            protectionRateInvalid(room.priceMin, room.priceMax, date['SUN'].value) 
                                                            ? 'protection-border-danger' 
                                                            : ''
                                                        ].filter(Boolean).join(' ')"
                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="date['SUN'].disable"
                                                        v-model.lazy="date['SUN'].value" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <v-row class="mt-0" v-if="roomIndex === 0">
                                    <v-col class="pt-0 pb-0">
                                        <v-btn color="primary" outlined x-small @click="addDatePriodSpecialPrice()">
                                            <i class="icon-add fs-14"></i>
                                            <span class="fs-8">{{ $t("ADD_DATE_RANGE") }}</span>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                            <hr class="mb-0" />
                        </div>
                    </template>
                </div>
            </template>
            <template v-if="popupBatchUpdate.price.hasRoomRate.filter(temp =>
                popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId)
            ).length === 0
                ">
                <v-col class="text-center">
                    <p style="color: #484646">{{ $t("NO_DATA") }}</p>
                </v-col>
            </template>
        </div>

        <div class="text-right pt-3 px-3" v-if="!popupBatchUpdate.isLoading">
            <v-btn color="primary" @click="confirmUpdateSpecialPrice()">
                <template>{{ $t("UPDATE") }}</template>
            </v-btn>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
// import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
    components: {
        "date-picker": () => import('vue2-datepicker'),
        "currency-ptd": () => import('@/components/Utils/Currency-input.vue'),
    },
    data() {
        return {
            panel: [0],
            currency: JSON.parse(localStorage.getItem("currency")),
            multiplierOption: {
                prefix: "",
                locale: "vi",
                length: 3,
                precision: 2
            },
            availOptions: {
                locale: "vi",
                length: 3,
                precision: 0
            },
            popupBatchUpdate: {
                isLoading: true,
                price: {
                    hasRoomRate: [],
                    selectedRoomType: [],
                },
                daysOfWeek: [
                    { code: "MON", value: this.$t("MONDAY") },
                    { code: "TUE", value: this.$t("TUESDAY") },
                    { code: "WED", value: this.$t("WEDNESDAY") },
                    { code: "THU", value: this.$t("THURSDAY") },
                    { code: "FRI", value: this.$t("FRIDAY") },
                    { code: "SAT", value: this.$t("SATURDAY") },
                    { code: "SUN", value: this.$t("SUNDAY") }
                ]
            },
            listRoom: [],
            currentDate: moment()
                .startOf("day")
                .toDate(),
            selectedDatePicker: moment()
                .startOf("day")
                .format("YYYY-MM-DD"),
            systemLang: this.$i18n.locale,
            maxDate: moment(this.currentDate)
                .add(2, "year")
                .add(14, "day")
                .format("YYYY-MM-DD"),
            selectedRoom: -1,
            objectCopy: null,
            updateErrors: {},
        };
    },
    computed: {},
    created() {
        this.currency = this.usedCurrency;
        this.initialize();
    },
    watch: {
        popupBatchUpdate: {
            handler(val) {
                val.price.hasRoomRate.forEach(room => {
                    room.dates.forEach(date => {
                        var start = moment(date.dateSelect[0], "YYYY-MM-DD");
                        var end = moment(date.dateSelect[1], "YYYY-MM-DD");

                        // Kiểm tra khoảng ngày hiện tại có lớn hơn 7, nếu lớn hơn thì enable tất cả, nếu ko thì xem khoảng ngày có ngày nào.
                        let day = moment.duration(end.diff(start)).asDays();

                        // Reset lại toàn bộ
                        if (day < 6) {
                            while (start <= end) {
                                let daysOfWeek = this.formatDateOfWeek(start);
                                // Mở các thứ ở trong khoảng
                                date[daysOfWeek].disable = false;
                                start = moment(start).add(1, "day");
                            }
                        } else {
                            // Nếu khoảng ngày trải dài cả tuần thì mở hết.
                            date.MON.disable = false;
                            date.TUE.disable = false;
                            date.WED.disable = false;
                            date.THU.disable = false;
                            date.FRI.disable = false;
                            date.SAT.disable = false;
                            date.SUN.disable = false;
                        }
                    });
                });
                this.updateErrors = {};
            },
            deep: true
        },
    },
    methods: {
        checkValidate() {
            const dateOfWeek = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
            this.updateErrors = {};
            let errors = [];
            this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
                //lấy priceMin, priceMax của từng loại phòng
                const priceMax = room.priceMax;
                const priceMin = room.priceMin;
                const message = priceMax != null && priceMin != null ? 
                    this.$t("SAFE_PRICE_RANGE.PROTECTION_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(priceMax), priceMin: this.formatCurrencyWithSymbol(priceMin)}) :
                        priceMax != null ? 
                        this.$t("SAFE_PRICE_RANGE.MAXIMUM_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(priceMax)}) :
                        this.$t("SAFE_PRICE_RANGE.MINIMUM_RATE_INPUT_INVALID", {priceMin: this.formatCurrencyWithSymbol(priceMin)});

                if (
                    this.popupBatchUpdate.price.selectedRoomType.includes(room.roomTypeId) &&
                    !errors.some(error => error.id === `${room.roomTypeId}`)
                ) {
                    room.dates.some(date => {
                        return dateOfWeek.some(day => {
                            if (
                                (priceMin != null && date[day].value && parseFloat(priceMin) > parseFloat(date[day].value)) ||
                                (priceMax != null && date[day].value && parseFloat(priceMax) < parseFloat(date[day].value))
                            ) {
                                errors.push({ id: `${room.roomTypeId}`, message });
                                return true;
                            }
                            return false;
                        });
                    });
                }
            });
            if (errors.length > 0) {
                const errorsObject = Object.fromEntries(
                    [...new Map(errors.map(item => [item.id, item.message]))]
                );
                this.updateErrors = errorsObject;
            }
            return Object.keys(this.updateErrors).length == 0;
        },
        async initialize() {
            this.popupBatchUpdate.isLoading = true;
            // Nếu là search thì không lấy lại list OTA nữa, ko dùng OTA đầu tiên như khi mới vào.
            this.currency = this.priceOptionsVi.suffix;
            this.getAllRoomDefault();
        },
        loadListRoom(data) {
            this.listRoom = [];
            this.listRoom = this.listRoom.concat(
                data.map(room => {
                    return {
                        value: room.id,
                        text: room.roomTypeI18n.find(x => x.lang === this.defaultI18n).name
                    };
                })
            );
            this.popupBatchUpdate.isLoading = false;
        },
        inDays(d1, d2) {
            var t2 = d2.getTime();
            var t1 = d1.getTime();

            return parseInt((t2 - t1) / (24 * 3600 * 1000));
        },
        copyPrice(date) {
            var value = null;
            if (!date.MON.disable) {
                value = date.MON.value;
            } else if (!date.TUE.disable) {
                value = date.TUE.value;
            } else if (!date.WED.disable) {
                value = date.WED.value;
            } else if (!date.THU.disable) {
                value = date.THU.value;
            } else if (!date.FRI.disable) {
                value = date.FRI.value;
            } else if (!date.SAT.disable) {
                value = date.SAT.value;
            } else if (!date.SUN.disable) {
                value = date.SUN.value;
            }
            date.MON.value = !date.MON.disable ? value : null;
            date.TUE.value = !date.TUE.disable ? value : null;
            date.WED.value = !date.WED.disable ? value : null;
            date.THU.value = !date.THU.disable ? value : null;
            date.FRI.value = !date.FRI.disable ? value : null;
            date.SAT.value = !date.SAT.disable ? value : null;
            date.SUN.value = !date.SUN.disable ? value : null;
        },
        changDate(ota) {
            let arrDate = [];
            ota.dates.forEach(element => {
                arrDate.push(element.dateSelect);
            });
            this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
                room.dates.forEach((date, index) => {
                    date.MON.disable = true;
                    date.TUE.disable = true;
                    date.WED.disable = true;
                    date.THU.disable = true;
                    date.FRI.disable = true;
                    date.SAT.disable = true;
                    date.SUN.disable = true;
                    date.dateSelect = arrDate[index];
                });
            });

        },
        async getAllRoomDefault() {
            this.popupBatchUpdate.price.hasRoomRate = [];
            const roomRateUpdateStore = JSON.parse(localStorage.getItem("roomRateUpdate"));
            await restriction.getAllRoomTyeHasRoomRate().then(res => {
                if (res.responseCode == 0) {
                    let fromDateListOfPeriod = moment(this.currentDate).format(
                        "YYYY-MM-DD"
                    );
                    let toDateListOfPeriod = moment(this.currentDate)
                        .add(1, "day")
                        .format("YYYY-MM-DD");
                    // List phòng đã có room rate cho cập nhật giá và giá đặc biệt
                    this.planList = [];
                    res.data.forEach(x => {
                        var temp = {
                            roomTypeId: x.id,
                            romTypeNameI18ns: x.roomTypeI18n,
                            dates: [
                                {
                                    dateSelect: [
                                        new Date(fromDateListOfPeriod),
                                        new Date(toDateListOfPeriod)
                                    ],
                                    MON: {
                                        value: null,
                                        disable: true
                                    },
                                    TUE: {
                                        value: null,
                                        disable: true
                                    },
                                    WED: {
                                        value: null,
                                        disable: true
                                    },
                                    THU: {
                                        value: null,
                                        disable: true
                                    },
                                    FRI: {
                                        value: null,
                                        disable: true
                                    },
                                    SAT: {
                                        value: null,
                                        disable: true
                                    },
                                    SUN: {
                                        value: null,
                                        disable: true
                                    }
                                }
                            ],
                            multiplier: 1,
                            plus: 0,
                            selectAll: false,
                            priceMin: x.priceMin,
                            priceMax: x.priceMax
                        };
                        this.popupBatchUpdate.price.hasRoomRate.push(temp);
                    });
                    this.loadListRoom(res.data);
                    this.popupBatchUpdate.price.selectedRoomType = roomRateUpdateStore.roomId && roomRateUpdateStore.roomId != -1 ? [roomRateUpdateStore.roomId] 
                                                                    : roomRateUpdateStore.roomId && roomRateUpdateStore.roomId == -1 ? this.listRoom.map(e => e.value) : [];
                    this.panel = this.popupBatchUpdate.price.hasRoomRate.map((k, i) => i)
                }
            });
        },
        copyMasterRate(detail) {
            const arrUpdate = [];
            this.popupBatchUpdate.price.hasRoomRate.forEach(r => {
                if (this.popupBatchUpdate.price.selectedRoomType.includes(r.roomTypeId)) {
                    arrUpdate.push(r.dates)
                }
            })
            let arrMap = [];
            arrMap = arrUpdate[0];
            arrMap.forEach((element, index) => {
                detail.dates[index]["MON"].value = detail.dates[index]["MON"].disable ? null : element["MON"].value * detail.multiplier + +detail.plus;
                detail.dates[index]["TUE"].value = detail.dates[index]["TUE"].disable ? null : element["TUE"].value * detail.multiplier + +detail.plus;
                detail.dates[index]["WED"].value = detail.dates[index]["WED"].disable ? null : element["WED"].value * detail.multiplier + +detail.plus;
                detail.dates[index]["THU"].value = detail.dates[index]["THU"].disable ? null : element["THU"].value * detail.multiplier + +detail.plus;
                detail.dates[index]["FRI"].value = detail.dates[index]["FRI"].disable ? null : element["FRI"].value * detail.multiplier + +detail.plus;
                detail.dates[index]["SAT"].value = detail.dates[index]["SAT"].disable ? null : element["SAT"].value * detail.multiplier + +detail.plus;
                detail.dates[index]["SUN"].value = detail.dates[index]["SUN"].disable ? null : element["SUN"].value * detail.multiplier + +detail.plus;
            });


        },
        copyMaster(detail) {
            this.objectCopy = [...detail];
        },
        pasteMaster(detail) {
            if (this.objectCopy) {
                this.objectCopy.forEach((element, index) => {
                    detail.dates[index]["MON"].value = element["MON"].value;
                    detail.dates[index]["TUE"].value = element["TUE"].value;
                    detail.dates[index]["WED"].value = element["WED"].value;
                    detail.dates[index]["THU"].value = element["THU"].value;
                    detail.dates[index]["FRI"].value = element["FRI"].value;
                    detail.dates[index]["SAT"].value = element["SAT"].value;
                    detail.dates[index]["SUN"].value = element["SUN"].value;
                });
            }
        },
        confirmUpdateSpecialPrice() {
            if (!this.checkValidate()) return;
            if (this.popupBatchUpdate.price.selectedRoomType.length === 0) {
				_alert("null", this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED"));
				return
			}
            let arrDate = [];
            let check = false;
            this.popupBatchUpdate.price.hasRoomRate.filter(temp => this.popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId))[0].dates.forEach(
                date => {
                    arrDate.push(date.dateSelect);
                }
            );
            const dates = [];
            arrDate.forEach((date) => {
                if (this.get_day_of_time(new Date(date[0]), new Date(date[1])) > 365) {
                    _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
                    check = true;
                    return true;
                }
                let fromDate = moment(date[0], "YYYY-MM-DD");
                let toDate = moment(date[1], "YYYY-MM-DD");
                while (fromDate <= toDate) {
                    dates.push(fromDate.format("YYYY-MM-DD"));
                    fromDate = moment(fromDate).add(1, "day");
                }
            });
            if (dates.filter((item, index) => dates.indexOf(item) !== index).length > 0) {
                _alert(null, this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME"));
                return;
            }

            var body = [];
            this.popupBatchUpdate.price.hasRoomRate.filter(temp => this.popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId)).forEach(room => {
                var dateValue = [];
                room.dates.forEach(date => {
                    let fromDate = moment(date.dateSelect[0], "YYYY/MM/DD");
                    let toDate = moment(date.dateSelect[1], "YYYY/MM/DD");
                    while (fromDate <= toDate) {
                        let daysOfWeek = this.formatDateOfWeek(fromDate);

                        if (
                            date[daysOfWeek].value != null && date[daysOfWeek].value != '' && 
                            date[daysOfWeek].value != "0"
                        ) {
                            dateValue.push({
                                apply: fromDate.format("YYYY-MM-DD"),
                                value: date[daysOfWeek].value
                            });
                        }
                        fromDate = moment(fromDate).add(1, "day");
                    }
                });
                if (dateValue.length > 0) {
                    body.push({
                        id: room.roomTypeId,
                        dates: dateValue
                    });
                }
                
            });
            this.popupBatchUpdate.isLoading = true;
            if (!check && body.length > 0) {
                this.popupBatchUpdate.isLoading = true;
                body.forEach(item => {
					item.dates.forEach(e => {
						e.value = this.formatMoney(+e.value, this.usedCurrency)
					})
				})
                sale_room
                    .updateSpecialPriceRoom(body)
                    .then(res => {
                        _alert(res, this.$t(res.data), false);
                    })
                    .finally(() => (this.popupBatchUpdate.isLoading = false));
            } else {
                _alert(null, this.$t("_VALIDATE.REQUIRED"));
                this.popupBatchUpdate.isLoading = false
            }
        },
        addDatePriodSpecialPrice() {
            let prevPeriod = this.popupBatchUpdate.price.hasRoomRate[0].dates[
                this.popupBatchUpdate.price.hasRoomRate[0].dates
                    .length - 1
            ];
            const tomorrow = new Date();
            tomorrow.setDate(new Date().getDate() + 365 * 2);
            if (
                new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >=
                tomorrow
            ) {
                return;
            }
            let from = moment(prevPeriod.dateSelect[1])
                .add(1, "day")
                .format("YYYY-MM-DD");
            let to = moment(prevPeriod.dateSelect[1])
                .add(2, "day")
                .format("YYYY-MM-DD");
            this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
                room.dates.push({
                    dateSelect: [new Date(from), new Date(to)],
                    MON: {
                        value: null,
                        disable: true
                    },
                    TUE: {
                        value: null,
                        disable: true
                    },
                    WED: {
                        value: null,
                        disable: true
                    },
                    THU: {
                        value: null,
                        disable: true
                    },
                    FRI: {
                        value: null,
                        disable: true
                    },
                    SAT: {
                        value: null,
                        disable: true
                    },
                    SUN: {
                        value: null,
                        disable: true
                    }
                });
            });

        },
        removePeriodSpecialPrice(index) {
            this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
                room.dates.splice(index, 1);
            });

        },
        formatDateOfWeek(date) {
            let dayOfWeek;
            switch (date.day()) {
                case 0: {
                    dayOfWeek = "SUN";
                    break;
                }
                case 1: {
                    dayOfWeek = "MON";
                    break;
                }
                case 2: {
                    dayOfWeek = "TUE";
                    break;
                }
                case 3: {
                    dayOfWeek = "WED";
                    break;
                }
                case 4: {
                    dayOfWeek = "THU";
                    break;
                }
                case 5: {
                    dayOfWeek = "FRI";
                    break;
                }
                case 6: {
                    dayOfWeek = "SAT";
                    break;
                }
            }
            return dayOfWeek;
        },
        _moment: moment
    }
};
</script>
